<template lang="pug">
div
  div(v-if="$vuetify.breakpoint.mobile" )
    div.d-flex.align-center.mt-3
      div.text-2xl.font-semibold.ml-4 {{ $store.state.ui.insightTitle }}
      v-spacer
      v-btn.mx-4(icon small  @click.stop='drawer = !drawer')
        eva-icon(name="menu-outline" :fill="$vuetify.theme.themes[$theme].primary500")
    v-navigation-drawer.white(v-model="drawer" app width="250")
      div(style="padding-top:75px")
        v-list(nav dense)
          v-list-item-group
            template(v-for="(menu, index) in sideMenu")
              v-list-item
                v-list-item-title
                  router-link(:to="menu.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="menu.id")
                    .font-semibold.text-md.px-3.py-2.mb-2(@click="navigate") {{ menu.title }}

    div.neutral300
      v-container.pa-5(style="max-width: 1600px")
        router-view
  div.d-flex(v-else)
    div.pa-8(style="width:280px; min-width:280px;")
      div(v-for="(menu, index) in sideMenu")
        router-link(:to="menu.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="menu.id")
          .font-semibold.text-md.px-3.py-2.mb-2(@click="navigate" :class="isActive ? 'selected-bg round-sm' : 'cursor-pointer neutral500--text'") {{ menu.title }}
    div.flex-grow-1.neutral200.h-screen
      div.neutral300
        v-container(style="max-width: 1600px")
          router-view
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Insights',
  components: {},
  computed: {
    ...mapGetters({
      isHq: 'hq/getIsHq'
    }),
    sideMenu() {
      return [
        { id: 'today', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/today`, title: 'Today' },
        { id: 'sales', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/sales`, title: 'Sales' },
        { id: 'in-clinic', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/in-clinic`, title: 'In-clinic' },
        { id: 'appointment', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/appointments`, title: 'Appointments' },
        { id: 'payments', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/payments`, title: 'Payments' },
        { id: 'inventory', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/inventory`, title: 'Inventory' },
        { id: 'patients', to: `/admin/${this.isHq ? 'hq' : 'clinic'}/insights/patients`, title: 'Patients' },
      ]
    }
  },
  data () {
    return {
      drawer: false
    }
  },
  mounted () {
    const currentPath = this.$router.currentRoute.path
    if (currentPath === '/admin/clinic/insights' || currentPath === '/admin/hq/insights') {
      this.$router.replace(this.sideMenu[0].to).catch(() => {})
    }
  }
}
</script>

<style lang="scss">
</style>